// import { useEffect } from 'react'

const ToApp = () => {
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Fetch the backend version
  //       const response = await fetch('/api/version')
  //       if (!response.ok) {
  //         throw new Error(`Failed to fetch backend version: ${response.status} ${response.statusText}`)
  //       }

  //       const { version } = await response.json()

  //       // Validate the version format (basic example, adjust regex as needed)
  //       const versionPattern = /^\d+\.\d+\.\d+$/ // Matches semantic versioning like '1.0.0'
  //       if (!versionPattern.test(version)) {
  //         throw new Error(`Invalid version format received: ${version}`)
  //       }

  //       // Construct the URL for the specific version
  //       const specificUrl = `https://cdn.example.com/main/v${version}/index.js`

  //       // Attempt to load the specific version
  //       try {
  //         const module = await import(/* @vite-ignore */ specificUrl)
  //         setMainApp(() => module.default)
  //       } catch (specificError) {
  //         console.warn(`Failed to load specific version: ${version}`, specificError)
  //         // Optionally, implement a fallback to a default version or handle gracefully
  //       }
  //     } catch (err) {
  //       console.error('Error loading main app:', err)
  //       setError(err.message)
  //     }
  //   }

  //   fetchData()
  // }, [])
  return <div>Login</div>
}

export default ToApp
